import React, { FC } from 'react'

import { getBlokContent } from '@app/utils/blok-content'
import { isNonEmptyArray } from '@app/utils/type-check'
import { SearchOverlayWrapper } from '@app/components/search-overlay-wrapper'
import { Blok } from '@app/typings/blok'
import { StoryblokComponent } from '@storyblok/react'

type Props = {
  header: Blok[]
  statusBanner: Blok[]
  footer: Blok[]
  search: Blok[]
  navigation: Blok[]
}

export const LayoutPage: FC<Props> = ({
  header,
  statusBanner,
  footer = [],
  search = [],
  navigation,
  children,
}) => {
  return (
    <div className="wrapper" style={{ minHeight: '100vh' }}>
      <SearchOverlayWrapper {...search[0]} />
      {header &&
        header.map((header) => (
          <StoryblokComponent
            key={header._uid}
            blok={{
              ...header,
              articleNavigation: getBlokContent(navigation),
            }}
            {...{
              ...header,
              articleNavigation: getBlokContent(navigation),
            }}
          />
        ))}

      <main role="main" className="main public-web-wrapper help-center-wrapper">
        {isNonEmptyArray(statusBanner) && (
          <StoryblokComponent blok={getBlokContent(statusBanner)} {...getBlokContent(statusBanner)} key={(getBlokContent(statusBanner))._uid} />
        )}
        {children}
      </main>

      <div className="bottom">
        {footer?.map((footer) =>  (
            <StoryblokComponent key={footer._uid} blok={getBlokContent([footer])} {...getBlokContent([footer])} />
          ))}
      </div>
    </div>
  )
}
